// Pantalla `command="login-oauth-grant"`. Port de la rama `when
// "login-oauth-grant"` de keycloak.coffee. Pantalla de consent OAuth:
// muestra los scopes solicitados y dos botones (Sí / No) que disparan
// custom submit con action accept|cancel.

import type { KcData } from "../kcData";
import { StandardPage } from "../components/StandardPage";
import { msg } from "../i18n";

interface OauthConsent {
  code: string;
  user?: {
    email: string;
    fullName?: string;
  };
  clientScopesRequested?: Array<{
    guiOrder?: number;
    label: string;
    name?: string;
  }>;
}

function getOauthConsent(data: KcData): OauthConsent | undefined {
  return (
    (data.form?.oauthConsent as OauthConsent | undefined) ??
    (data as unknown as { oauthConsent?: OauthConsent }).oauthConsent
  );
}

export interface LoginOauthGrantPageProps {
  data: KcData;
  running: boolean;
  onCustomSubmit: (action: "accept" | "cancel") => void;
}

export function LoginOauthGrantPage(props: LoginOauthGrantPageProps) {
  const { data, running, onCustomSubmit } = props;
  const consent = getOauthConsent(data);
  const scopes =
    consent?.clientScopesRequested?.filter((s) => s.guiOrder) ?? [];
  const email = consent?.user?.email.trim() ?? "";
  const fullName = consent?.user?.fullName?.trim();
  const authorizingUser =
    fullName && fullName !== email ? `${fullName} (${email})` : email;

  return (
    <StandardPage page="login-oauth-grant" data={data}>
      <div>
        <form
          id="kc-form-actions"
          action={data.url!.oauthAction}
          method="post"
        >
          <input type="hidden" name="code" value={consent?.code ?? ""} />
          {authorizingUser ? (
            <>
              <p className="instruction oauth-user">
                {msg("oauthGrantAsUser")} <strong>{authorizingUser}</strong>
              </p>
              <p className="note oauth-switch-user">
                {msg("oauthGrantDifferentUser")}
              </p>
            </>
          ) : null}
          <p className="instruction">{msg("oauthGrantInstruction")}</p>
          <div className="form-group oauth-scopes">
            <ul>
              {scopes.map((s, i) => (
                /* El label viene ya resuelto por el FTL: prueba la
                   key fd_scope_<name> en messages y, si no existe, cae
                   en advancedMsg — traducción propia de Keycloak para
                   los scopes built-in, literal tal cual para el resto.
                   Ver login-oauth-grant.ftl. Tras el label, el id del
                   scope entre paréntesis — "Lectura de contactos
                   (contacts:read)" — omitido si el label ya es el
                   propio id o si el FTL no supo deducirlo (name
                   vacío: built-in de Keycloak sin mapear). */
                <li key={i}>
                  {s.label}
                  {s.name && s.name !== s.label ? ` (${s.name})` : ""}
                </li>
              ))}
            </ul>
          </div>
          <div className="form-group">
            <button
              type="button"
              className="btn btn-lg btn-block btn-primary"
              disabled={running}
              onClick={() => onCustomSubmit("accept")}
            >
              {msg("doYes")}
            </button>
          </div>
          <div className="form-group">
            <button
              type="button"
              className="btn btn-lg btn-block btn-default"
              disabled={running}
              onClick={() => onCustomSubmit("cancel")}
            >
              {msg("doNo")}
            </button>
          </div>
        </form>
      </div>
    </StandardPage>
  );
}
